export const STATE_MAP_TYPE: Record<string, string> = {
  AL: "maps/alabama",
  AK: "maps/alaska_boroughs",
  AS: "maps/americansamoa",
  AZ: "maps/arizona",
  AR: "maps/arkansas",
  CA: "maps/california",
  CO: "maps/colorado",
  CT: "maps/connecticut_planning_regions",
  DC: "maps/districtofcolumbia",
  DE: "maps/delaware",
  FL: "maps/florida",
  FM: "maps/micronesia",
  GA: "maps/georgia",
  GU: "maps/guamcongressional",
  HI: "maps/hawaii",
  ID: "maps/idaho",
  IL: "maps/illinois",
  IN: "maps/indiana",
  IA: "maps/iowa",
  KS: "maps/kansas",
  KY: "maps/kentucky",
  LA: "maps/louisiana",
  ME: "maps/maine",
  MD: "maps/maryland",
  MA: "maps/massachusetts",
  MH: "maps/marshallisland",
  MI: "maps/michigan",
  MN: "maps/minnesota",
  MP: "maps/NorthernMarianaIslands",
  MS: "maps/mississippi",
  MO: "maps/missouri",
  MT: "maps/montana",
  NE: "maps/nebraska",
  NV: "maps/nevada",
  NH: "maps/newhampshire",
  NJ: "maps/newjersey",
  NM: "maps/newmexico",
  NY: "maps/newyork",
  NC: "maps/northcarolina",
  ND: "maps/northdakota",
  OH: "maps/ohio",
  OK: "maps/oklahoma",
  OR: "maps/oregon",
  PA: "maps/pennsylvania",
  PW: "maps/palau",
  PR: "maps/puertorico",
  RI: "maps/rhodeisland",
  SC: "maps/southcarolina",
  SD: "maps/southdakota",
  TN: "maps/tennessee",
  TX: "maps/texas",
  UT: "maps/utah",
  VT: "maps/vermont",
  VA: "maps/virginia",
  VI: "maps/usvirginisland",
  WA: "maps/washington",
  WV: "maps/westvirginia",
  WI: "maps/wisconsin",
  WY: "maps/wyoming",
};
export const STATE_KEY_BY_ABBR: Record<string, string> = {
  AL: "alabama",
  AK: "alaska",
  AZ: "arizona",
  AR: "arkansas",
  CA: "california",
  CO: "colorado",
  CT: "connecticut",
  DE: "delaware",
  FL: "florida",
  GA: "georgia",
  HI: "hawaii",
  ID: "idaho",
  IL: "illinois",
  IN: "indiana",
  IA: "iowa",
  KS: "kansas",
  KY: "kentucky",
  LA: "louisiana",
  ME: "maine",
  MD: "maryland",
  MH: "marshallisland",
  MA: "massachusetts",
  MI: "michigan",
  FM: "micronesia",
  MN: "minnesota",
  MS: "mississippi",
  MO: "missouri",
  MT: "montana",
  NE: "nebraska",
  NV: "nevada",
  NH: "newhampshire",
  NJ: "newjersey",
  NM: "newmexico",
  NY: "newyork",
  NC: "northcarolina",
  ND: "northdakota",
  OH: "ohio",
  OK: "oklahoma",
  OR: "oregon",
  PA: "pennsylvania",
  RI: "rhodeisland",
  SC: "southcarolina",
  SD: "southdakota",
  TN: "tennessee",
  TX: "texas",
  UT: "utah",
  VT: "vermont",
  VA: "virginia",
  WA: "washington",
  WV: "westvirginia",
  WI: "wisconsin",
  WY: "wyoming",
  PR: "puertorico",
  PW: "palau",
  VI: "usvirginisland",
};

interface MapVersion {
  mapType: string;
  valid: [number, number?];
}

export const STATE_MAP_VERSIONS: Record<string, MapVersion[]> = {
  CT: [
    { mapType: "maps/connecticut", valid: [1994, 2022] },
    { mapType: "maps/connecticut_planning_regions", valid: [2023] },
  ],
  AK: [
    { mapType: "maps/alaska_boroughs_1994_2013", valid: [1994, 2013] },
    { mapType: "maps/alaska_boroughs_2014_2015", valid: [2014, 2015] },
    { mapType: "maps/alaska_boroughs_2016_2021", valid: [2016, 2021] },
    { mapType: "maps/alaska_boroughs_2022_present", valid: [2022] },
  ],
  VA: [
    { mapType: "maps/virginia_1994_2013", valid: [1994, 2013] },
    { mapType: "maps/virginia_2014_presesnt", valid: [2014] },
  ],
};

export function getMapType(stateAbbr: string, year: string | number): string {
  const numYear = Number(year);
  const versions = STATE_MAP_VERSIONS[stateAbbr];

  if (versions) {
    const match = versions.find((v) => {
      const [from, to] = v.valid;
      return numYear >= from && (to === undefined || numYear <= to);
    });
    if (match) return match.mapType;
  }

  return STATE_MAP_TYPE[stateAbbr];
}

export const territoryMapping: Record<string, {}> = {
  MP: {
    Rota: "001",
    Saipan: "002",
    Tinian: "003",
  },
  VI: {
    "Saint Croix": "vi.us.sc",
    "Saint John": "vi.us.sj",
    "Saint Thomas": "vi.us.st",
  },
  FM: {
    Chuuk: "fm.ch",
    Kosrae: "fm.ko",
    Pohnpei: "fm.po",
    Yap: "fm.ya",
  },
  GU: {
    Guam: "98",
  },
  MH: {
    Ailinglapalap: "mh.mh.ai",
    Ailuk: "mh.mh.ee",
    Arno: "mh.mh.ar",
    Aur: "mh.mh.er",
    Bikini: "mh.mh.bn",
    Ebon: "mh.mh.eb",
    Enewetak: "mh.mh.en",
    Jaluit: "mh.mh.jl",
    Kili: "mh.mh.kn",
    Kwajalein: "mh.mh.kw",
    Likiep: "mh.mh.lk",
    Majuro: "mh.mh.mj",
    Maloelap: "mh.mh.ml",
    Mejit: "mh.mh.me",
    Mili: "mh.mh.mi",
    Namdrik: "mh.mh.nk",
    Namu: "mh.mh.nu",
    Rongelap: "mh.mh.rl",
    Ujae: "mh.mh.uj",
    Ujelang: "mh.mh.ul",
    Utirik: "mh.mh.ut",
    Wotho: "mh.mh.wh",
    Wotje: "mh.mh.wj",
    Toke: "mh.mh.to",
    Taongi: "mh.mh.ta",
    Bikar: "mh.mh.br",
    Rongrik: "mh.mh.rr",
    Kosrae: "mh.mh.ko",
  },
  PW: {
    Aimeliik: "pw.ai",
    Airai: "pw.ar",
    Angaur: "pw.an",
    Hatohobei: "pw.ha",
    Kayangel: "pw.ka",
    Koror: "pw.ko",
    Melekeok: "pw.me",
    Ngaraard: "pw.ng",
    Ngarchelong: "pw.nc",
    Ngardmau: "pw.nd",
    Ngatpang: "pw.nt",
    Ngchesar: "pw.ns",
    Ngeremlengui: "pw.nr",
    Ngiwal: "pw.nw",
    Peleliu: "pw.pe",
    Sonsorol: "pw.so",
  },
};
